"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCommentTokens = void 0;
var lodash_1 = require("lodash");
var EditorTypes_1 = require("./../EditorTypes");
var getCommentTokens = function (tokens) {
    var flattenedTokens = [];
    tokens.forEach(function (token) {
        switch (token.subType) {
            case EditorTypes_1.BlockType.Table: {
                (0, lodash_1.flattenDeep)(token.cells).forEach(function (tableToken) {
                    flattenedTokens.push(tableToken);
                });
                break;
            }
            case EditorTypes_1.BlockType.SideBySide: {
                (0, lodash_1.flattenDeep)([token.column1, token.column2]).forEach(function (sideBySideToken) {
                    flattenedTokens.push(sideBySideToken);
                });
                break;
            }
            case EditorTypes_1.BlockType.Accordion: {
                (0, lodash_1.flattenDeep)([token.heading, token.body]).forEach(function (accordionToken) {
                    flattenedTokens.push(accordionToken);
                });
            }
            default: {
                flattenedTokens.push(token);
            }
        }
    });
    return flattenedTokens.filter(function (token) { return token.type == EditorTypes_1.MarkType.Comment; });
};
exports.getCommentTokens = getCommentTokens;
